import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import axios from "axios";
import { base_api_url } from "../../../environment.jsx";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { QrCode, Mail, ArrowLeft, CheckCircle } from "lucide-react";
import "./forgotpassword.css";

const MySwal = withReactContent(Swal);

const Forgotpassword = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${base_api_url}api/forgot-password`, { email });

      setSubmitted(true);
    } catch (error) {
      let errorMessage = "Une erreur est survenue. Veuillez réessayer.";
      if (error.response?.status === 404) {
        errorMessage = "Aucun compte trouvé avec cette adresse e-mail.";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.request) {
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion.";
      }

      MySwal.fire({
        icon: "error",
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        customClass: { popup: "pixel-toast" },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fp-container">
      {/* Section Gauche : Branding */}
      <div className="fp-left-section">
        <div className="fp-blur-effect"></div>

        <div className="fp-left-content">
          <div className="fp-logo-wrapper" onClick={() => navigate("/")}>
            <div className="fp-logo-icon">
              <QrCode />
            </div>
            <span className="fp-logo-text">
              QR<span className="fp-logo-text-accent">NYAMA</span>
            </span>
          </div>
          <h2 className="fp-main-title">
            Récupérez <br />
            <span className="fp-title-accent">votre accès.</span>
          </h2>
          <p className="fp-left-subtitle">
            Un lien de réinitialisation vous sera envoyé par e-mail afin que
            vous puissiez définir un nouveau mot de passe en toute sécurité.
          </p>
        </div>

        <p className="fp-copyright">© 2026 QRNYAMA. Tous droits réservés.</p>
      </div>

      {/* Section Droite : Formulaire */}
      <div className="fp-right-section">
        <div className="fp-form-container">
          {/* Logo mobile */}
          <div className="fp-mobile-logo">
            <div className="fp-mobile-logo-content">
              <div className="fp-mobile-logo-icon">
                <QrCode />
              </div>
              <span className="fp-mobile-logo-text">
                QR<span className="fp-logo-text-accent">NYAMA</span>
              </span>
            </div>
          </div>

          {!submitted ? (
            <>
              {/* En-tête formulaire */}
              <div className="fp-header">
                <div className="fp-icon-wrapper">
                  <Mail size={28} />
                </div>
                <h3 className="fp-header-title">Mot de passe oublié ?</h3>
                <p className="fp-header-subtitle">
                  Saisissez votre adresse e-mail et nous vous enverrons un lien
                  de réinitialisation.
                </p>
              </div>

              {/* Formulaire */}
              <form onSubmit={handleSubmit} className="fp-form">
                <div className="fp-form-group">
                  <label className="fp-label">Adresse e-mail</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="nom@restaurant.com"
                    className="fp-input"
                    autoFocus
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="fp-submit-btn"
                >
                  {loading ? (
                    <span className="fp-btn-loading">
                      <span className="fp-spinner"></span>
                      Envoi en cours...
                    </span>
                  ) : (
                    "Envoyer le lien de réinitialisation"
                  )}
                </button>
              </form>

              {/* Lien retour */}
              <p className="fp-footer-text">
                <Link to={route.signin} className="fp-back-link">
                  <ArrowLeft size={14} />
                  Retour à la connexion
                </Link>
              </p>
            </>
          ) : (
            /* État succès */
            <div className="fp-success-state">
              <div className="fp-success-icon">
                <CheckCircle size={40} />
              </div>
              <h3 className="fp-success-title">E-mail envoyé !</h3>
              <p className="fp-success-message">
                Un lien de réinitialisation de mot de passe a été envoyé à{" "}
                <strong>{email}</strong>. Vérifiez votre boîte de réception
                (et vos spams) afin de procéder à la réinitialisation.
              </p>
              <p className="fp-success-note">
                Le lien est valable pendant <strong>30 minutes</strong>.
              </p>
              <button
                onClick={() => setSubmitted(false)}
                className="fp-resend-btn"
              >
                Renvoyer l&apos;e-mail
              </button>
              <Link to={route.signin} className="fp-back-link fp-back-center">
                <ArrowLeft size={14} />
                Retour à la connexion
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Forgotpassword;
